export default "/iconClose--small.svg";